import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { ShowFileConstatComponent } from '../addconstat/addconstat.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-view-pdf',
  templateUrl: './view-pdf.component.html',
  styleUrls: ['./view-pdf.component.scss']
})
export class ViewPDFComponent implements OnInit {
  title = 'viewer-app';
  pdfSrc = "";

  //pdfSrc="https://localhost:8000/storage/Contrat/1677691023_xIdx7nlo1K3FkF7oiTgX.pdf"

  constructor(
    public dialogRef: MatDialogRef<ShowFileConstatComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 

    
  }

  ngOnInit(): void {
    console.log(this.data.url)
    //this.pdfSrc = this.data.url;
  }


}
